(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  /*
    Camada de vídeo de fundo do hero. Custom element (convenção do tema,
    CLAUDE.md item 7) em vez de um script solto por dois motivos práticos:
    o connectedCallback roda de novo sozinho quando o Theme Editor
    re-renderiza a section (um script no corpo da section não roda), e
    cada slide do carrossel tem a própria instância sem precisar varrer o
    documento.

    Por que o src não vem do Liquid: `<source media>` dentro de video não
    é honrado de forma confiável pelos navegadores (diferente de
    <picture>), então a escolha entre a peça desktop e a mobile é feita
    aqui, uma vez, antes de qualquer byte de vídeo ser pedido — o
    elemento nasce com preload="none" e sem src justamente pra isso.
  */
  class WsHeroVideo extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;

      this.video = this.querySelector('video');
      if (!this.video) return;

      // Quem pediu menos animação no sistema não baixa o arquivo — a
      // imagem embaixo já conta a mesma história. É por isso que a
      // checagem vem antes de definir o src, e não só um CSS escondendo
      // a camada depois de baixar tudo.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // Mesma lógica aplicada à conexão (21/09/2026): em economia de dados
      // ou rede lenta, um banner decorativo de alguns MB é a última coisa
      // que a cliente quer gastar. `navigator.connection` não existe no
      // Safari, e aí o `if` simplesmente não dispara — o comportamento
      // padrão continua sendo tocar.
      var conn = navigator.connection;
      if (conn) {
        var slow = ['slow-2g', '2g', '3g'].indexOf(conn.effectiveType) !== -1;
        if (conn.saveData === true || slow) return;
      }

      // Só começa a baixar DEPOIS do load da página. Antes disso o vídeo
      // disputava banda com a primeira foto e virava o elemento de LCP da
      // home (medido: 5,47 MB e LCP no <video>, item 9 do CLAUDE.md). A
      // imagem embaixo é quem deve ganhar essa corrida — o vídeo entra
      // quando o resto já está de pé.
      if (document.readyState === 'complete') {
        this.start();
      } else {
        window.addEventListener('load', this.start.bind(this), { once: true });
      }
    }

    start() {
      if (this.loaded || !this.video) return;

      var isDesktop = window.matchMedia('(min-width: 750px)').matches;
      var src = isDesktop
        ? this.dataset.srcDesktop
        : this.dataset.srcMobile || this.dataset.srcDesktop;
      if (!src) return;

      this.loaded = true;

      // A camada só aparece quando o vídeo está tocando DE VERDADE
      // (evento playing, não canplay): se o autoplay for recusado — iPhone
      // em Modo de Baixo Consumo é o caso comum — a imagem embaixo
      // continua sendo o que a cliente vê, sem frame congelado nem caixa
      // preta no lugar do banner.
      this.video.addEventListener('playing', this.reveal.bind(this), { once: true });

      // muted no atributo E na propriedade: o Safari ignora o atributo
      // quando o src é definido por JS depois do parse, e um vídeo não
      // mudo nunca ganha autoplay em navegador nenhum.
      this.video.muted = true;
      this.video.src = src;
      this.play();

      this.watchVisibility();
    }

    // Vídeo fora da tela não precisa decodificar frame nenhum — vale pro
    // scroll (hero some no topo) e pro carrossel, onde cada slide tem a
    // própria instância e os que não estão em cena ficariam rodando à toa.
    watchVisibility() {
      var self = this;
      this.visibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) self.play();
            else self.video.pause();
          });
        },
        { threshold: 0 }
      );
      this.visibilityObserver.observe(this);
    }

    play() {
      var attempt = this.video.play();
      if (attempt) attempt.catch(function () {});
    }

    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
    }

    reveal() {
      this.classList.add('is-playing');
    }
  }

  customElements.define('ws-hero-video', WsHeroVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-sticky-atc"]) return;
  try {
    
  class WsStickyAtc extends HTMLElement {
    connectedCallback() {
      // Escopado à section cujo id termine em "__main" — em template
      // JSON o id real é "shopify-section-{prefixo}__main" (prefixo
      // muda por loja/tema), não "shopify-section-main" puro. Isso pra
      // não pegar o botão/preço de um eventual featured-product na
      // mesma página — main-product.liquid e featured-product.liquid
      // usam as mesmas classes/ids.
      this.mainSection = document.querySelector('[id$="__main"]');
      this.mainSectionId = this.mainSection?.id.replace('shopify-section-', '');

      this.targetButton = this.mainSection?.querySelector('.product-form__submit');
      this.button = this.querySelector('.ws-sticky-atc__cta');
      this.buttonText = this.querySelector('.ws-sticky-atc__cta-text');
      this.spinner = this.querySelector('.loading__spinner');
      this.priceContainer = this.querySelector('.ws-sticky-atc__price');
      this.sizeBadge = this.querySelector('.ws-sticky-atc__size');
      this.sizeBadgeText = this.querySelector('.ws-sticky-atc__size-text');
      // document.querySelector, não this.querySelector: <modal-dialog>
      // (assets/global.js) se move pra ser filho direto do <body> no
      // PRÓPRIO connectedCallback dele, que pode rodar antes ou depois
      // deste — se já tiver rodado, o sheet não é mais descendente de
      // <ws-sticky-atc> e this.querySelector retornaria null (bug real,
      // achado em teste no navegador — o sheet ficava sempre indisponível
      // e a barra nunca sincronizava tamanho). Section é singleton
      // (enabled_on.templates: ["product"], uma instância por página), então
      // buscar por classe no documento inteiro é seguro.
      this.sheetEl = document.querySelector('.ws-sticky-atc__sheet');
      this.realPriceWrapper = this.mainSection?.querySelector('[id^="price-"]');
      // cartError não identifica o form de origem além do productVariantId
      // (assets/product-form.js) — precisamos da variante atual do form
      // principal pra filtrar erros de outro form na mesma página (ex.:
      // quick-add do ws-style-with.liquid, que publica o mesmo evento
      // global pra um produto/variante diferente).
      this.currentVariantId = this.mainSection?.querySelector('[name="id"]')?.value ?? null;

      if (!this.targetButton || !this.button) {
        this.remove();
        return;
      }

      this.button.addEventListener('click', () => {
        if (this.needsSizeSelection()) {
          this.sheetEl.show(this.button);
          return;
        }
        this.targetButton.click();
      });

      this.sizeBadge?.addEventListener('click', () => this.sheetEl.show(this.sizeBadge));

      this.sheetEl?.addEventListener('click', (event) => {
        const option = event.target.closest('.ws-sticky-atc__sheet-option');
        if (!option) return;
        // Esgotado não seleciona nada e não fecha o sheet — o toque é
        // engolido de propósito, pra cliente continuar vendo as opções
        // que existem em vez de sair do sheet com uma variante
        // impossível de comprar escolhida.
        if (option.getAttribute('aria-disabled') === 'true') return;
        this.selectSize(option.dataset.sizeValue);
      });

      this.syncPrice();
      this.syncSize(); // também chama syncState() internamente

      // Troca de variante (tamanho etc.) já dispara um aviso do Dawn com
      // dado pronto (product-info.js) — mais confiável que vigiar o DOM
      // mudar, e sobrevive se o Dawn mudar como ele renderiza a troca.
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId !== this.mainSectionId) return;
        if (event.data.variant?.id) this.currentVariantId = String(event.data.variant.id);
        this.syncPrice();
        this.syncSize();
      });

      // Mesma ideia pro erro de add-to-cart (ex.: esgota entre o load e o
      // clique) — o Dawn já publica isso, em vez de eu vigiar o wrapper
      // de erro escondido/visível no DOM. Payload vem plano (sem .data),
      // diferente do variantChange acima — conferido direto em
      // assets/product-form.js. errors pode vir como objeto (erro de
      // validação de quantidade), não string — só usa se for texto.
      // Payload também não diz qual form publicou (source é sempre
      // "product-form", tanto o principal quanto o quick-add do
      // ws-style-with.liquid) — só productVariantId diferencia. Ignora
      // erro de variante diferente da que a barra está mostrando agora.
      this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
        if (String(event.productVariantId) !== String(this.currentVariantId)) return;
        const message = typeof event.message === 'string' ? event.message : null;
        const errors = typeof event.errors === 'string' ? event.errors : null;
        this.syncError(message || errors);
      });

      // O único estado sem aviso pronto: a janela entre apertar comprar e
      // a resposta do servidor. product-form.js seta aria-disabled e a
      // classe loading direto no botão real nesse intervalo — não tem
      // pub/sub pra isso, só resta vigiar essas duas coisas.
      this.loadingObserver = new MutationObserver(() => this.syncLoading());
      this.loadingObserver.observe(this.targetButton, {
        attributes: true,
        attributeFilter: ['aria-disabled', 'class'],
      });

      // Encolhe o viewport de detecção pela altura real da barra (medida,
      // não a constante --ws-space-12) — agora varia com
      // env(safe-area-inset-bottom) em aparelhos com home indicator, então
      // um valor fixo desalinharia o gatilho nesses aparelhos.
      const barHeight = this.getBoundingClientRect().height || 112;
      this.visibilityObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          // `isIntersecting: false` sozinho é ambíguo — acontece tanto
          // quando o botão real JÁ FICOU PRA TRÁS (rolou pra cima, saiu
          // por cima da viewport) quanto quando ele AINDA NÃO CHEGOU
          // (mais abaixo na buy box, nunca foi visível ainda — ex.:
          // cliente ainda lendo o swatch, bem antes do botão real).
          // Sem distinguir os dois, a barra aparecia cedo demais, no
          // segundo caso (bug real, auditado 31/08/2026). Fix: só reagir
          // quando o sinal é inequívoco — visível agora (mostra o botão
          // real, esconde a barra) ou confirmado acima da viewport via
          // `boundingClientRect.top < 0` (ficou pra trás de verdade,
          // mostra a barra). Fora desses dois casos (ainda não chegou),
          // não mexe em nada — o estado inicial já é hidden-bar/inert
          // (barra escondida), o padrão seguro enquanto não tem certeza.
          if (entry.isIntersecting) {
            this.toggleAttribute('hidden-bar', true);
            this.toggleAttribute('inert', true);
          } else if (entry.boundingClientRect.top < 0) {
            this.toggleAttribute('hidden-bar', false);
            this.toggleAttribute('inert', false);
          }
        },
        { rootMargin: `0px 0px -${barHeight}px 0px` }
      );
      this.visibilityObserver.observe(this.targetButton);
    }

    disconnectedCallback() {
      this.variantChangeUnsubscriber?.();
      this.cartErrorUnsubscriber?.();
      this.loadingObserver?.disconnect();
      this.visibilityObserver?.disconnect();
    }

    // Sempre relidos do DOM (nunca cacheados) — product-info.js substitui
    // o nó inteiro de <variant-selects> a cada troca de variante, então
    // uma referência guardada de antes de uma troca ficaria presa a um
    // elemento desconectado.
    getSizeInputs() {
      return Array.from(this.mainSection?.querySelectorAll('input[data-option-name]') ?? []).filter(
        (input) => input.dataset.optionName?.trim().toLowerCase() === 'size'
      );
    }

    targetButtonDisabled() {
      return this.targetButton.disabled || this.targetButton.getAttribute('aria-disabled') === 'true';
    }

    needsSizeSelection() {
      if (!this.sheetEl) return false;
      if (this.targetButtonDisabled()) return false;
      return !this.getSizeInputs().some((input) => input.checked);
    }

    selectSize(value) {
      const input = this.getSizeInputs().find((candidate) => candidate.value === value);
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.sheetEl.hide();
    }

    syncSize() {
      if (!this.sheetEl) {
        this.syncState();
        return;
      }

      const checked = this.getSizeInputs().find((input) => input.checked);

      // O chip fica sempre visível (21/09/2026): sem tamanho escolhido
      // ele repete o convite do botão principal ("Select size") em vez de
      // sumir, porque "nenhum tamanho escolhido" é o estado de entrada da
      // PDP desde o ws-size-gate — escondido, o atalho pro bottom-sheet
      // só existia depois de já ter escolhido pela buy box. Manter o chip
      // no DOM também evita a linha do preço mudar de layout no meio da
      // navegação.
      if (checked) {
        this.sizeBadgeText.textContent = `${this.dataset.sizeLabel || 'Size'}: ${checked.value}`;
      } else {
        this.sizeBadgeText.textContent = this.dataset.selectSizeText || 'Select size';
      }

      this.sheetEl.querySelectorAll('.ws-sticky-atc__sheet-option').forEach((optionButton) => {
        const isSelected = !!checked && optionButton.dataset.sizeValue === checked.value;
        optionButton.setAttribute('aria-pressed', String(isSelected));
        optionButton.classList.toggle('ws-sticky-atc__sheet-option--selected', isSelected);
      });

      this.syncState();
    }

    syncState() {
      // Depois de um erro, esse texto fica preso na mensagem de erro até
      // o cliente tentar de novo (syncLoading limpa hasError nesse
      // momento) — sem essa guarda, o aria-disabled voltando ao normal no
      // .finally() do Dawn (ele faz isso mesmo em erro) sobrescreveria a
      // mensagem antes do cliente conseguir ler.
      if (this.hasError) return;

      if (this.needsSizeSelection()) {
        this.button.disabled = false;
        this.buttonText.textContent = this.dataset.selectSizeText || 'Select size';
        return;
      }

      this.button.disabled = this.targetButtonDisabled();
      // Só o span de TEXTO do botão real, não o textContent inteiro
      // (21/09/2026): desde snippets/ws-atc-price.liquid, o botão da PDP
      // também carrega um segundo span com o preço da variante, e copiar
      // o textContent traria "Add to cart $83.97" pra cá — sendo que esta
      // barra já mostra o preço na linha 1, do lado do chip de tamanho.
      // O primeiro span é o do texto por construção: é o mesmo que o Dawn
      // usa como `submitButtonText` (assets/product-form.js:13) e o único
      // que existia antes; o do preço é sempre acrescentado depois dele.
      const targetText = this.targetButton.querySelector('span') || this.targetButton;
      this.buttonText.textContent = targetText.textContent.trim();
    }

    syncPrice() {
      if (!this.priceContainer || !this.realPriceWrapper) return;
      const realPrice = this.realPriceWrapper.querySelector('.price');
      if (realPrice) this.priceContainer.innerHTML = realPrice.outerHTML;
    }

    syncLoading() {
      const isLoading = this.targetButton.classList.contains('loading');
      if (isLoading) this.hasError = false; // nova tentativa começando, limpa erro anterior
      this.button.classList.toggle('loading', isLoading);
      this.spinner?.classList.toggle('hidden', !isLoading);
      this.syncState();
    }

    syncError(message) {
      this.hasError = true;
      this.buttonText.textContent = message || this.buttonText.textContent;
      this.button.disabled = false;
      this.button.classList.remove('loading');
      this.spinner?.classList.add('hidden');
    }
  }

  customElements.define('ws-sticky-atc', WsStickyAtc);

  } catch(e) { console.error(e); }
})();
})();
